import React, { Component } from "react";
import Header from "../component/header/Header";
import FooterTwo from "../component/footer/FooterTwo";
import { AiOutlineDown, AiOutlineRight, AiOutlineClose, AiFillPlayCircle, AiFillPauseCircle } from "react-icons/ai";
import { FcDataProtection } from "react-icons/fc";
import axios from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import Selectrix from "react-selectrix";
import ReactCountryFlag from "react-country-flag";
import 'react-tabs/style/react-tabs.css';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';
import { Helmet } from 'react-helmet-async';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import Modal from "react-bootstrap/Modal";
import FlipCountdown from '@rumess/react-flip-countdown';
import { toast } from 'react-toastify';
import ReactPlayer from "react-player";
import ProgressBar from 'react-bootstrap/ProgressBar';
import { IoCloseCircleOutline } from "react-icons/io5";
import { MdWork, MdEmail, MdPayments, MdModeNight, MdOutlineZoomOutMap } from "react-icons/md";
import { FiCheck, FiClock, FiUser, FiMonitor, FiRadio, FiDownload, FiVideo, FiCheckCircle, FiPackage} from "react-icons/fi";
import { FaGraduationCap, FaPhone, FaRunning, FaEye, FaWhatsapp, FaPaypal, FaCreditCard } from "react-icons/fa";
import { HiMiniPencilSquare } from "react-icons/hi2";


// const KeyCountry =  [
//     {key: "MX", label: "México", countryNumber: "+52"},
//     {key: "EC", label: "Ecuador", countryNumber: "+593"},
//     {key: "CR", label: "Costa Rica", countryNumber: "+506"},
//     {key: "GT", label: "Guatemala", countryNumber: "+502"},
//     {key: "UY", label: "Uruguay", countryNumber: "+598"},
//     {key: "HN", label: "Honduras", countryNumber: "+504"},
//     {key: "SV", label: "El Salvador", countryNumber: "+503"},
//     {key: "PE", label: "Perú", countryNumber: "+51"},
//     {key: "PY", label: "Paraguay", countryNumber: "+595"},
//     {key: "PA", label: "Panamá", countryNumber: "+507"},
//     {key: "NI", label: "Nicaragua", countryNumber: "+505"},
//     {key: "US", label: "Estados Unidos", countryNumber: "+1"},
    
// ]

const KeyCountry = [
    { key: "US", label: "United States", countryNumber: "+1" },
    { key: "SG", label: "Singapore", countryNumber: "+65" },
    { key: "AU", label: "Australia", countryNumber: "+61" },
    { key: "GB", label: "United Kingdom", countryNumber: "+44" },
    { key: "CA", label: "Canada", countryNumber: "+1" },
    { key: "NZ", label: "New Zealand", countryNumber: "+64" },
    { key: "IE", label: "Ireland", countryNumber: "+353" }
]


const KeyPaymentType =  [
    {key: "1", label: "PAGO AL CONTADO"},
    {key: "3", label: "PAGO EN 2 CUOTAS"},
]



class InscripcionUSA extends Component{
    constructor () {
        super()
        this.state = {
            isCurso: false,
            fechaLimite: '',
            fecha_inicio: '',
            duracion: '',
            langUS: false,
            isPricePais: false,
            price_view_base : '',
            price_view_final : '',
            price_view_descuento : '',
            isFlex: false,
            unicoPago: false,
            pagoCuota: false,
            numeroCuota: 1,
            active_offer: true,
            isSuscription: false,
            is_mensual: false,
            black_friday: false,
            countryPhone: "",
            typePaymentSelect: 'card',
            loadingNext: false,
            showPaymentMetod: false,
            loadingPay: false,
            loadingCupon: false,
            title: "",
          isOpen: false,
          select_mes: "",
          select_turno: "",
          Email: "",
          Name: "",
          LastName: "",
          Phone: "",
          select_fecha: "fecha_1",
          countryCode: 'CA',
          slugBootcamp: '',
          dataApi: {},
          price_pais: "",
          price_dolares: "",
          price_payment: 0,
          pay_currency_code: 'CAD',
          bootcamp: "webfullstack",
          planPago: false,
          optionPlanPago: "0",
          KeysPlanes: [
            {"label": "Entrada Gratuita", "key": "0"},
            {"label": "💎 Acceso VIP (US$ 3)", "key": "1"}
          ],
          KeysFechas: [],
          cuotas: false,
          fechasPago: [],
          showPaypal: false,
          payOption: "card",
          isModalDeposito: false,
          isFlashEspecial: false,
          FlashBody: '',
          modeIntro: false,
          fechas: [],
          activeBeca: null,
          slugOficial: "webfullstack",
          isModalBecaOff: false,
          priceConversion: null,
          garantia: false,
          porcentajeDescuento: null,
          showMore: false,
          linkPayPeru: "",
          linkPayPeru2: "",
          linkPayPeru3: "",
          timeCounter: "",
          showDeadLine: false,
          showVsl: false,
          urlVid: "",
          showTestimonial: false,
          showButton: false,
          isOpen2: false,
        initialOptions: {
    clientId: "AZeHtz9ynRf6LBFEZCIwQcl-wGC6rVlfGKTH44LBcZ9BVs-INyQQ3VpFYAFWAdX2m2GjMhZBmTQ4Dw-C",
    currency: "CAD",
    intent: "capture",
    locale: "en_CA",
},
        linkPayUSD: "",
        linkPayMXN: "",
        linkPayUSD2: "",
        linkPayUSD3: "",       
        linkPayUSD4: "", 
        showPayal: false,
        cupones: false,
        Cupon: "",
        cuponActive: false,
        ahorroPeru: "",
        ahorroUSD: "",
        optionCuotas: [],
        cuotaSelect: "1",
        asunto: "",
        isCountryUsa: false,
        }
        this.CreateLinkPay = this.CreateLinkPay.bind(this);
        this.validateCupon = this.validateCupon.bind(this);
        this.GetLinkWS = this.GetLinkWS.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.changeMethodPay = this.changeMethodPay.bind(this);
        this.paypalButtonsRef = React.createRef();
    }


    obtenerDiaActual() {
        try {
            const diasDeLaSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
            const fechaActual = new Date();
            const diaActual = fechaActual.getDay(); // Obtiene el índice del día (0=domingo, 1=lunes, etc.)
            return diasDeLaSemana[diaActual]; // Devuelve el día correspondiente en texto
        } catch (error) {
            return ""
        }
    }



    eventPing(name_event) {
        const config = {
          method: 'get',
          url: `https://api.dojofullstack.com/api/v1/crm/event/${name_event}`,
          headers: { 
            'Authorization': '0101010010001'
          }
        };
        axios(config)
          .then(response => {})
          .catch(error => {});
      };

      
    
    sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }


    changeMethodPay(option, config){

        if (config !== "set"){
            this.onSubmit();
        }

        if (option === 'card'){
            this.setState({payOption: "card"});
            try {
                document.querySelector('#option-card').checked = true;
            } catch (error) {}
            document.querySelector('#modal-card').style.backgroundColor = 'ghostwhite';
            // document.querySelector('#modal-card').style.border = '2px solid purple';
            document.querySelector('#modal-card').style.boxShadow = 'rgba(50, 27, 98, 0.47) 6px 5px 15px 0px';

            if (document.querySelector('#modal-paypal')){
                document.querySelector('#option-paypal').checked = false;
                document.querySelector('#modal-paypal').style.border = '1px solid #c6c9d8';
                document.querySelector('#modal-paypal').style.boxShadow = 'none';
                document.querySelector('#modal-paypal').style.backgroundColor = 'white';
            }
            if (document.querySelector('#modal-deposito')){
                document.querySelector('#option-deposito').checked = false;
                document.querySelector('#modal-deposito').style.border = '1px solid #c6c9d8';
                document.querySelector('#modal-deposito').style.boxShadow = 'none';    
                document.querySelector('#modal-deposito').style.backgroundColor = 'white';
            }
            if (document.querySelector('#modal-yape')){
                document.querySelector('#option-yape').checked = false;
                document.querySelector('#modal-yape').style.border = '1px solid #c6c9d8';
                document.querySelector('#modal-yape').style.boxShadow = 'none';    
                document.querySelector('#modal-yape').style.backgroundColor = 'white';
            }

        } else if (option === 'paypal'){
            this.setState({payOption: "paypal"});
            document.querySelector('#option-paypal').checked = true;
            // document.querySelector('#modal-paypal').style.border = '2px solid purple';
            document.querySelector('#modal-paypal').style.boxShadow = 'rgba(50, 27, 98, 0.47) 6px 5px 15px 0px';
            document.querySelector('#modal-paypal').style.backgroundColor = 'ghostwhite';

            document.querySelector('#option-card').checked = false;
            document.querySelector('#modal-card').style.border = '1px solid #c6c9d8';
            document.querySelector('#modal-card').style.boxShadow = 'none';
            document.querySelector('#modal-card').style.backgroundColor = 'white';

            if (document.querySelector('#modal-deposito')){
                document.querySelector('#option-deposito').checked = false;
                document.querySelector('#modal-deposito').style.border = '1px solid #c6c9d8';
                document.querySelector('#modal-deposito').style.boxShadow = 'none';   
                document.querySelector('#modal-deposito').style.backgroundColor = 'white'; 
            }

        } else if (option === 'deposito'){
            this.setState({payOption: "deposito"});
            document.querySelector('#option-deposito').checked = true;
            document.querySelector('#option-card').checked = false;
            
            // document.querySelector('#modal-deposito').style.border = '2px solid purple';
            document.querySelector('#modal-deposito').style.boxShadow = 'rgba(50, 27, 98, 0.47) 6px 5px 15px 0px';
            document.querySelector('#modal-deposito').style.backgroundColor = 'ghostwhite';

            document.querySelector('#modal-card').style.border = '1px solid #c6c9d8';
            document.querySelector('#modal-card').style.boxShadow = 'none';     
            document.querySelector('#modal-card').style.backgroundColor = 'white';  
            
            document.querySelector('#modal-yape').style.border = '1px solid #c6c9d8';
            document.querySelector('#modal-yape').style.boxShadow = 'none';    
            document.querySelector('#modal-yape').style.backgroundColor = 'white';

            // document.querySelector('#modal-paypal').style.border = '1px solid #c6c9d8';
            // document.querySelector('#modal-paypal').style.boxShadow = 'none';
            // document.querySelector('#option-paypal').checked = false;
        } else if (option === 'yape'){
            this.setState({payOption: "yape"});
            document.querySelector('#option-yape').checked = true;
            // document.querySelector('#option-card').checked = false;

            // document.querySelector('#modal-yape').style.border = '2px solid purple';
            document.querySelector('#modal-yape').style.boxShadow = 'rgba(50, 27, 98, 0.47) 6px 5px 15px 0px';
            document.querySelector('#modal-yape').style.backgroundColor = 'ghostwhite';

            document.querySelector('#modal-deposito').style.border = '1px solid #c6c9d8';
            document.querySelector('#modal-deposito').style.boxShadow = 'none';     
            document.querySelector('#modal-deposito').style.backgroundColor = 'white';  


            document.querySelector('#modal-card').style.border = '1px solid #c6c9d8';
            document.querySelector('#modal-card').style.boxShadow = 'none';     
            document.querySelector('#modal-card').style.backgroundColor = 'white';  

        }

    }

    onSubmit(e) {
        try {
            e.preventDefault();            
        } catch (error) { }

        



        // console.log(this.state.pay_currency_code);
        // console.log(this.state.initialOptions);
        if (this.state.Email.trim() === "" || !this.state.Email.trim().includes("@") ) {
            toast.dark('¡Ups! El campo Email es necesario para continuar.');
            return;
        }

   window.fbq('track', 'Lead', {
            content_name: 'Purchase Bootcamp',
            content_category: 'Full Stack Developer Online'
          });

        window.fbq('track', 'InitiateCheckout');

        // if(this.state.Name === "" ){
        //     toast.dark('El campo Nombre es requerido.');
        //     return;
        // }

        // if(this.state.Phone === "" ){
        //     toast.dark('El campo Celular es requerido.');
        //     return;
        // }


        localStorage.setItem('email', this.state.Email || "");
        localStorage.setItem('name', this.state.Name || "");
        localStorage.setItem('phone', this.state.Phone || "");


        axios.post('https://cprij4toee.execute-api.us-east-1.amazonaws.com/dev',
        {prospecto: true, bootcamp: this.state.slugBootcamp, plan: this.state.Plan, email: this.state.Email, name: this.state.Name, phone: this.state.Phone, country: this.state.countryCode, lastname: this.state.LastName, optionPlanPago: this.state.optionPlanPago},)
        .then(res => {
            console.log("Data Saved");
            
            // this.setState({showPaymentMetod: true, loadingPay: false});
            // try {
            //     // document.querySelector('#option-card').checked = true;
            //     // if (this.state.countryCode !== "PE"){
            //     //     this.changeMethodPay("paypal");
            //     // } else {
            //     //     this.changeMethodPay("card");
            //     // }
            // } catch (error) {
            //     this.setState({loadingPay: false});
            //     console.log(error);
            // }
            // window.scrollTo(0, 0);

        })
    }


    GetLinkWS(){
        let texto = "Hola, me gustaría obtener más información sobre el bootcamp de desarrollador full stack.";

        if (window.type_device){
            return `https://api.whatsapp.com/send?phone=51936670597&text=${texto}`;
        } else {
            return `https://api.whatsapp.com/send?phone=51936670597&text=${texto}`;
        }
    }



    onRenderOption ( option, index ) {
        return (<li key={index} style={{padding: "6px", fontSize: "16px"}}>
                { option.label }
                </li>)
    }

    onRenderSelectionPais( selected, settings, deselect ){
        return 	(<span style={{ marginRight: 10, padding: 5 }}>
		{ selected ?
            <span style={{"color": "#1f1f25"}}>
                <ReactCountryFlag
                countryCode={selected.key}
                svg
                style={{
                    width: '2.3em',
                    height: '2.3em',
                    padding: '7px'
                }}
                title="país"
        />  {selected.countryNumber}
            </span>
            :
               <span style={{padding: 5}}>País</span>
        }
        
		<i style={{ paddingLeft: 5, cursor: "pointer" }} onClick={ deselect } className="fa fa-window-close"></i>
	</span>)
    }


    
    onRenderOptionPlan ( option, index ) {
        return (<li key={index} style={{padding: "6px", fontSize: "16px"}}>
                { option.label }
                </li>)
    }



    onRenderSelection( selected, settings, deselect ){
        return 	(<span style={{ marginRight: 0, padding: 5 }}>
		{ selected ?
            <span style={{"color": "#1f1f25", padding: "7px", fontSize: "16px"}}>
               {selected.label}
            </span>
            :
               <span style={{padding: 5}}>Modalidad</span>
        }
		<i style={{ paddingLeft: 5, cursor: "pointer" }} onClick={ deselect } className="fa fa-window-close"></i>
	</span>)
    }


    onRenderSelectionPlan( selected, settings, deselect ){
        return 	(<span style={{ marginRight: 10, padding: 5 }}>
		{ selected ?
            <span style={{"color": "#1f1f25", padding: "10px", fontSize: "18px", fontWeight: "bold"}}>
               {selected.label}
            </span>
            :
               <span style={{padding: 5}}>Selecciona</span>
        }
		<i style={{ paddingLeft: 5, cursor: "pointer" }} onClick={ deselect } className="fa fa-window-close"></i>
	</span>)
    }

 DynamicCountry(country, data, title, price="price"){

    let priceDefault = "";
    let priceMount = 0;

    priceDefault = data[title][price].usd.mount;
    priceMount = data[title][price].usd.mount;

    let price_view_base = data[title][price].usd.price_view_base;
    let price_view_final = data[title][price].usd.price_view_final;
    let price_view_descuento = data[title][price].usd.price_view_base_regular;


    this.setState({
        isPricePais: false,
        countryCode: country,
        price_dolares: priceDefault,
        price_payment: priceMount,
        price_view_base,
        price_view_final,
        price_view_descuento,
    })


    if (data[title][price][country]){

        let priceMountPais = data[title][price][country].mount;

        this.setState({
            isPricePais: true,
            price_payment: priceMountPais,
            price_view_base: data[title][price][country].price_view_base,
            price_view_final: data[title][price][country].price_view_final,
            price_view_descuento: data[title][price][country].price_view_base_regular,
        
        });
    }
   


    // this.sleep(1000).then(r => {
    //     this.changeMethodPay("card", "set");
    // })

    this.sleep(2000).then(r => {
        this.setState({showPayal: true})
    })
    



 }


    selectCuota(cuota){

        this.setState({cuotaSelect: cuota});

        const slugBootcamp = this.props.match.params.bootcamp.toLowerCase();
        if (cuota === "1"){
            // console.log(this.state.dataApi[this.props.match.params.bootcamp.toLowerCase()]["price"].usd.price_view_base);
            this.DynamicCountry(this.state.countryCode, this.state.dataApi, slugBootcamp, "price");

        } else if (cuota === "2"){
            // console.log(this.state.dataApi[this.props.match.params.bootcamp.toLowerCase()]["price-cuota-2"].usd.price_view_base);
            this.DynamicCountry(this.state.countryCode, this.state.dataApi, slugBootcamp, "price-cuota-2");

        } else if (cuota === "3") {
            // console.log(this.state.dataApi[this.props.match.params.bootcamp.toLowerCase()]["price-cuota-3"].usd.price_view_base);
            this.DynamicCountry(this.state.countryCode, this.state.dataApi, slugBootcamp, "price-cuota-3");
        }
    }




    OpenWS(){

        let messsageWasi;
        if (true || window.location.pathname.includes("en-fullstack")){
            messsageWasi = "Hello, I would like to inquire about registering for the Full Stack Web Bootcamp.";
        } else {
            messsageWasi = "Hola, me gustaría obtener más información sobre el bootcamp de desarrollador full stack.";
        }

        if (window.type_device){
            window.open("https://api.whatsapp.com/send?phone=51936670597&text=" + messsageWasi, '_blank').focus();
        } else {
            window.open("https://api.whatsapp.com/send?phone=51936670597&text=" + messsageWasi, '_blank').focus();
        }
    }


    validateCupon(){

        if (this.state.Cupon.trim() === ""){
            return;
        }

        this.setState({loadingCupon: true});

        // console.log(this.state.cupones);
        // console.log(this.state.Cupon);

        if (this.state.cupones.includes(this.state.Cupon.trim().toLocaleUpperCase().replace(/['"]/g, '') )){
            // console.log("CUPON VALIDO, GENERANDO REDIRECCION");
            if (this.state.Email){
                localStorage.setItem('email', this.state.Email);
            }
            if (this.state.Name){
                localStorage.setItem('name', this.state.Name);
            }
            if (this.state.Phone){
                localStorage.setItem('phone', this.state.Phone);
            }

            this.sleep(2000).then(r => {
                window.location.href = `/enroll/${this.state.Cupon.trim().toLocaleLowerCase().replace(/['"]/g, '')}/${this.state.countryCode}`;
            })
            return;
        } else {

            this.sleep(1000).then(r => {
                toast.dark('¡Ups! El código de descuento no es válido.');
                this.setState({loadingCupon: false});
            })

        
        }

    }



    CreateLinkPay(){

        // console.log("this.state.linkPayUSD3", this.state.linkPayUSD3);

        

        this.setState({loadingPay: true});


        this.onSubmit();

         this.sleep(1900).then(r => {

                if (this.state.countryCode === "PE"){
                    window.location.assign(this.state.linkPayPeru);
                } else {
                    window.location.assign(this.state.linkPayUSD);
                }
                
                // if (this.state.cuotaSelect === "1"){
                //     window.location.assign(this.state.linkPayUSD);
                // } else if (this.state.cuotaSelect === "2"){
                //     window.location.assign(this.state.linkPayUSD2);
                // } else if (this.state.cuotaSelect === "3"){
                //     window.location.assign(this.state.linkPayUSD3);
                // }
        })


        return;

        let descriptionPay = this.state.title;

        descriptionPay = `${this.state.title}`;

        
        this.setState({loadingPay: true});
        axios.post('https://z8gez0imi4.execute-api.us-east-1.amazonaws.com/dev', {
            name: `${this.state.Name} ${this.state.LastName}` ,
            email: this.state.Email,
            mount: this.state.price_payment,
            description:  descriptionPay,
            country:  !true ? this.state.countryCode: 'US',
          }).then((response) => {
            this.setState({loadingPay: false});
            let data = response.data;
            let urlPay = data.data.payment_method.url;
            window.location.replace(urlPay);

            }).catch((error) => {
                this.setState({loadingPay: false});
                console.log(error);
            });
    }


    render(){
        return(
            <React.Fragment>


                {true || window.location.pathname.includes("en-fullstack") ?
                      <Helmet>
                      <title>Bootcamp enrollment | DojoFullStack</title>
                      <meta name="description"
                          content="Become a Full Stack Web Developer in our Bootcamp, master the Frontend and Backend of a website using HTML, CSS, JavaScript, React, Python and AWS, receive the Employability Program upon completion. Create real web projects and learn the best programming practices at DojoFullStack!"
                          />
                      <meta
                          property="og:description"
                          content="Become a Full Stack Web Developer in our Bootcamp, master the Frontend and Backend of a website using HTML, CSS, JavaScript, React, Python and AWS, receive the Employability Program upon completion. Create real web projects and learn the best programming practices at DojoFullStack!"
                          />
                     <meta
                          name="twitter:description"
                          content="Become a Full Stack Web Developer in our Bootcamp, master the Frontend and Backend of a website using HTML, CSS, JavaScript, React, Python and AWS, receive the Employability Program upon completion. Create real web projects and learn the best programming practices at DojoFullStack!"
                      />
                  </Helmet>
                :
                <Helmet>
                    <title>Bootcamp Inscripción | DojoFullStack</title>
                    <meta name="description"
                        content="Conviértete en Desarrollor Web Full Stack en nuestro Bootcamp, domina el Frontend y el Backend de un sitio web usando HTML, CSS, JavaScript, React, Python y AWS, recibe el Programa de empleabilidad al finalizar. ¡Crea proyectos web reales y aprende las mejores prácticas de programación en DojoFullStack!"
                        />
                    <meta
                        property="og:description"
                        content="Conviértete en Desarrollor Web Full Stack en nuestro Bootcamp, domina el Frontend y el Backend de un sitio web usando HTML, CSS, JavaScript, React, Python y AWS, recibe el Programa de empleabilidad al finalizar. ¡Crea proyectos web reales y aprende las mejores prácticas de programación en DojoFullStack!"
                        />
                <meta
                        name="twitter:description"
                        content="Conviértete en Desarrollor Web Full Stack en nuestro Bootcamp, domina el Frontend y el Backend de un sitio web usando HTML, CSS, JavaScript, React, Python y AWS, recibe el Programa de empleabilidad al finalizar. ¡Crea proyectos web reales y aprende las mejores prácticas de programación en DojoFullStack!"
                    />
                 </Helmet>
            }


            <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" register={true} langUS={true} />


    { (this.state.showDeadLine && this.state.isFlashEspecial && this.state.timeCounter !== "") &&
    <div id="counter-deadline" className="pt-1 pb-2">
        <h5 className="w-100 mt-2 mb-1 text-white text-center px-1" style={{fontSize: "17px"}} > 
            {this.state.porcentajeDescuento}
        </h5>
        <h5 className="my-0" style={{fontSize: "18px", color: "black", textAlign: "center", fontWeight: "normal"}} >
            
        Pago único de solo {this.state.price_view_base}, ¡Últimas horas para obtener el descuento!
        </h5>
        <FlipCountdown
                            size={'small'}
                            yearTitle='Year'
                            dayTitle='Días'
                            hourTitle='Horas'
                            minuteTitle='Min'
                            secondTitle='Segs'
                            monthTitle=''
                            hideYear
                            hideMonth
                            hideDay
                            endAt={this.state.timeCounter?.toISOString()} // Date/Time
                            onTimeUp={() => {location.href = "/"} }
                            />
    </div>
    }


            <div className="breadcrumb-area rn-bg-color bg_image " style={{height: window.type_device ? "70px": "85px", backgroundColor: "rgb(75, 0, 130)"}} data-black-overlay="6">
            </div>

            <div>




             

  {/* Start About Area */}
  {false &&
  <div data-aos="fade-up" className="about-area bg_color--5" id="about_dojopy" style={{marginTop: "20px", marginBottom: "20px"}}>
                    <div className="about-wrapper">
                        <div className="container px-1">
                            <div className="row row--35 align-items-center justify-content-center">

                                <div className="col-12 col-md-10 px-1">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title">

                                                {!true ? "Bootcamp Web Full Stack": "Full Stack Web Bootcamp"}

                                            <span style={{padding: "3px", marginLeft: "8px", "background-color": "tomato", "border-radius": "7px", "padding-left": "7px", "padding-right": "7px", "color": "white", "font-size": "20px"}}>
                                                <span class="pulsar"></span> {!true ? "En vivo": "Live"}
                                            </span>
                                            </h2>
                                            <p>
                                           <b>
                                        Somos una Startup educativa, el aliado que te acompaña para desarrollarte como programador y desarrollador web full stack, durante y después del Bootcamp.
                                        </b>
                                            </p>
                                            <p>
                                            Aprenderás a crear plataformas web modernas y escalables desde cero como <b>Rappi, Airbnb o Twitter. 🔥</b>. <br/>
                                            Domina el <b>Frontend</b> y el <b>Backend</b> de un sitio web usando las mejores prácticas conocidas y la programación. <br/>

                                            </p>


                                        </div>

                                    <div className="row mt--30 rn-address" style={{boxShadow: "#c6c9d8 8px 6px 15px 1px"}} >
                                            <div className="col-lg-4 col-md-6 col-sm-12 col-12" style={{marginTop: window.type_device? "10px": "1px"}}>
                                                <div className="about-us-list">
                                                    <h3 className="title"><FiClock/> {!true ? "Duración": "Duration"}</h3>
                                                    <p style={{fontSize: "18px"}}>
                                                    <span style={{"color":"slateblue", "fontSize": "18px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
                                                    {!true ? "2 meses": "5 months"} 
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 col-sm-12 col-12" style={{marginTop: window.type_device? "10px": "1px"}}>
                                                <div className="about-us-list">
                                                    <h3 className="title"><FiUser/>  {!true ? "Modalidad": "Modality"} </h3>
                                                    <p style={{fontSize: "18px"}}>
                                                    <span style={{"color":"slateblue", "fontSize": "18px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span> 100% online
                                                    <span style={{padding: "3px", marginLeft: "7px", "background-color": "tomato", "border-radius": "7px", "padding-left": "7px", "padding-right": "7px", "color": "white", "font-size": "18px"}}>
                                                        <span class="pulsar"></span> {!true ? "En vivo": "Live"}
                                                    </span>
                                                     <br/>
                                                        <div className="pt-2">
                                                        <span style={{"color":"slateblue", "fontSize": "18px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>  {!true ? "Sesiones grupales y mentorías personalizadas." : "Receive Mentoring 1 to 1"}<br/>
                                                        </div>
                                                    </p>
                                                </div>
                                            </div>


                                            <div className="col-lg-4 col-md-6 col-sm-12 col-12" style={{marginTop: window.type_device? "10px": "1px"}}>
                                                <div className="about-us-list">
                                                    <h3 className="title"><FiRadio/> {!true ? "Dedicación": "Dedication"} </h3>
                                                    <p style={{fontSize: "18px"}}>
                                                    <span style={{"color":"slateblue", "fontSize": "18px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>

                                                     3 sesiones semanales (100% prácticas)
                                                     <br/>

                                                    <div className="pt-2">
                                                    <span style={{"color":"slateblue", "fontSize": "18px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
                                                    5 horas en vivo y 2 horas asíncronas, cada semana.
                                                    </div>
                                                    </p>
                                                </div>
                                            </div>

                                      


                                            <div className="col-lg-4 col-md-6 col-sm-12 col-12" style={{marginTop: window.type_device? "10px": "1px"}}>
                                                <div className="about-us-list">
                                                    <h3 className="title"> {!true ? "Requisitos": "Requirements"} </h3>
                                                    <p style={{fontSize: "20px"}}>
                                                    <span style={{"color":"slateblue", "fontSize": "20px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
                                                    <a style={{"cursor": "pointer", "text-decoration": "underline"}} onClick={() => this.setState({isOpen2: !this.state.isOpen2})}> {!true ? "Ver": "View"}</a>

                                                    </p>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-6 col-sm-12 col-12" style={{marginTop: window.type_device? "10px": "1px"}}>
                                                <div className="about-us-list">
                                                    <h3 className="title"> {!true ? "Temario": "Syllabus"} </h3>
                                                    <p style={{fontSize: "20px"}}>
                                                    <button className="rn-button-style--2 btn-solid" style={{fontSize: "18px", padding: "10px"}} onClick={() => {
                                                        window.open("https://media.dojofullstack.com/temario-pdf/FULLSTACK-2024_update.pdf", '_blank');
                                                    } }>
                                                <FiDownload style={{fontSize: "18px", margin: "3px"}}/>
                                                <b>Ver Temario </b>
                                                </button>
                                                    </p><br/>
                                                </div>
                                            </div>


                                            <div className="col-12" style={{marginTop: window.type_device? "10px": "1px"}}>
                                                <h3 className="title"><FaGraduationCap/>   Múltiple Certificación </h3>
                                                <div className="row justify-content-center">
                                                <div className="about-us-list col-6 col-md-2 col-lg-2"  >
                                                    <img onContextMenu={(e) => e.preventDefault()} alt="Certificado Web Full Stack Developer" src={"/assets/images/dojopy/CERTIFICADO-FS.png"}></img>
                                                </div>
                                           
                                                <div className="about-us-list col-6 col-md-2 col-lg-2"  >
                                                    <img onContextMenu={(e) => e.preventDefault()} alt="Certificado Frontend Developer" src={"/assets/images/dojopy/cert_frontend_react_2023.webp"}></img>
                                                </div>
                                                <div className="about-us-list col-6 col-md-2 col-lg-2"  >
                                                    <img onContextMenu={(e) => e.preventDefault()} alt="Certificado Backend Developer" src={"/assets/images/dojopy/cert_backend_python_2023.webp"}></img>
                                                </div>
                                                <div className="about-us-list col-6 col-md-2 col-lg-2"  >
                                                    <img onContextMenu={(e) => e.preventDefault()} alt="Certificado Cloud AWS Developer" src={"/assets/images/dojopy/cert_cloud_aws_2023.webp"}></img>
                                                </div>

                                                </div>
                                            </div>

                                    </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
    }
                {/* End About Area */}







            {/* Start About Area */}
            <div data-aos="fade-up" className="about-area ptb--20 bg_color--5">
                    <div className="about-wrapper">
                 
                        <div className="container" style={{marginTop: "5px"}}>
                        
                     


    



    { this.state.showDeadLine && this.state.isFlashEspecial && !this.state.showVsl &&
        <div className="mb-5"> </div>
    }

    <div className="row row--35 m-auto" style={{justifyContent: "space-evenly", gap: "10px"}}>
    
        <div className="col-12 col-md-6 " style={{height: '100%' , maxWidth: "490px", marginBottom: "25px", "box-shadow": "rgba(50, 27, 98, 0.47) 6px 5px 15px 0px", "border-radius": "20px", "background": "white"}}>
            <div className="about-inner inner pt-1">


{true &&
<>
    <div className="section-title mt-3 mb-1 d-flex">


    <h3 className="title mb-2" style={{paddingLeft:  window.type_device ? "1px" : "9px"}}>
     <HiMiniPencilSquare className="mr-1"/>  {true ? "Registration Data": "Registration Data"}  
    </h3>
    </div>


<div className="contact-form--1" style={{ paddingTop: "10px" }}>
            <form>
                <div className="row" style={{paddingLeft: !window.type_device ? "10px" : "", paddingRight: !window.type_device ? "10px" : ""}}>
                    <label class="col-12" htmlFor="item01">
                    <b style={{fontSize: "17px"}}>
                    
                    {true ? "👤 Name:": "👤 Nombre:"}
                    </b>

                    <input
                    type="text"
                    name="name"
                    id="item01"
                    value={this.state.Name}
                    onChange={(e) => {
                        this.setState({ Name: e.target.value });
                    }}
                    placeholder={true ? "Name": "Nombre"}
                    />
                </label>


                <label class="col-12" htmlFor="item02">
                     <b style={{fontSize: "17px"}}>

{true ? "📧 Email:": "📧  Correo Electrónico: "}
                    </b>
                    <input
                    type="email"
                    name="email"
                    id="item02"
                    value={this.state.Email}
                    onChange={(e) => {
                        this.setState({ Email: e.target.value });
                    }}
                    placeholder={true ? "email@gmail.com": "correo@ejemplo.com"}
                    />
                </label>
                


                <div className="text-left" >
                    <b style={{fontSize: "17px", marginLeft: "16px"}}>
                   
                    {true ? "📱 Cell Phone Number:": "📱 N.º de Celular:"}
                    </b>
                </div>


                <div className="d-flex justify-content-center mx-3">
                
                <div className="mx-2 mt-2">
                    <Selectrix
                    className="pais-inscription"
                    height={300}
                    onRenderOption={this.onRenderOption}
                    onRenderSelection={this.onRenderSelectionPais}
                    placeHolderInside={true}
                    placeholder={"Country"}
                    customScrollbar={true}
                    searchable={false}
                    materialize={false}
                    defaultValue={this.state.countryCode}
                    options={KeyCountry}
                    onChange={(value) => {
                        if (this.state.Email){
                            localStorage.setItem('email', this.state.Email);
                        }
                        if (this.state.Name){
                            localStorage.setItem('name', this.state.Name);
                        }
                        if (this.state.Phone){
                            localStorage.setItem('phone', this.state.Phone);
                        }
                        
                        if (value.key && !this.isCountryUsa){
                            window.location.href = `/enroll/${this.state.slugBootcamp}/${value.key}`;
                        }
                    } }
                    />

                </div>

                <div style={{width: "80%"}}>
                <label htmlFor="Phone">
                    
                    <input
                    style={{background: "white"}}
                    type="tel"
                    name="phone"
                    id="Phone"
                    value={this.state.Phone}
                    onChange={(e) => {
                        this.setState({ Phone: e.target.value });
                    }}
                    placeholder={true ? "Cellular Number": "N.º Celular" }
                    />
                 </label>
                </div>
              
                </div>


            {/* <div className="col-12 mt-0" style={{color: "white", fontSize: "14px", textAlign: "left", display: "inline-block"}}>
            <label htmlFor="checkNotify" style={{float: "left", color: "#1f1f25"}}>
                <input
                    style={{width: 15, float: "left", marginTop: "-12px", marginRight: "5px", marginBottom: "1px"}} 
                    defaultChecked={true}
                    type="checkbox"
                    name="checkNotify"
                    id="checkNotify"
                />
                <span>
                        Protección de datos y privacidad.
                    <FcDataProtection style={{fontSize: "20px"}} /> </span>
            </label>
            </div> */}

    
            {this.state.cuotas &&
                <>
                   <div className="text-left w-100 px-3" >
                    <div className="section-title mt-1 mb-0 d-flex">
                        <h3 className="title" style={{fontSize: window.type_device ? "25px": "25px"}}>
                            Formas de Pago:</h3>
                    </div>

                    
    <p className="pb-1" style={{fontSize: "17px", color: "#333"}}>
    Elige tu forma de pago: Al Contado o en Cuotas.
    </p>

                </div>


                <div className="d-flex justify-content-center mx-3 flex-column w-100">
                
                <div className="mx-2 mt-2">
                    <Selectrix
                    className="pais-inscription cuotas-inscription"
                    height={300}
                        onRenderOption={this.onRenderOption}
                        onRenderSelection={this.onRenderSelectionPlan}
                        placeHolderInside={true}
                        placeholder={""}
                        customScrollbar={true}
                        searchable={false}
                        materialize={false}
                        defaultValue={this.state.cuotaSelect}
                        options={KeyPaymentType}
                        onChange={(value) => {
                            this.setState({cuotaSelect: value.key});
                            this.selectCuota(value.key);
                        }}
                    />
                </div>

        {this.state.cuotaSelect === "1" &&  <>
        
            <div className="mx-2 row my-1" style={{cursor: "pointer", border: "1px solid mediumspringgreen", padding: "10px", justifyContent: "center"}}>

                <label className="col-12 mx-0 px-0 py-1" style={{cursor: "pointer"}} for="cuota1"  >
                    <div className="d-flex text-center" style={{justifyContent: "center", fontSize: "16px"}}>
                        <span style={{fontWeight: "bold", fontSize: "18px"}}>

                        {
                            this.state.FlashBody ?
                            <>
                                {this.state.FlashBody} {this.state.price_view_base}
                            </>:
                            <>
                                Paga al Contado y aprovecha un descuento exclusivo: {this.state.price_view_base}
                            </>
                        }
                        </span>
                    </div>
                </label>
            </div>
        </>}

        {this.state.cuotaSelect === "3" &&  <>
        
        <div className="mx-2 row my-1" style={{cursor: "pointer", border: "1px solid darkorange", padding: "10px", justifyContent: "center"}}>

            <label className="col-12 mx-0 px-0 py-1" style={{cursor: "pointer"}} for="cuota1"  >
                <div className="d-flex text-center" style={{justifyContent: "center", fontSize: "16px"}}>
                    <span style={{fontWeight: "bold", fontSize: "18px"}}>
                    Flexibilidad: Distribuye tu pago en 2 meses de {this.state.optionCuotas[0]}
                    </span>
                </div>
            </label>
        </div>
    </>}

                </div>



                
            {false &&  <>
                <div onClick={() => this.selectCuota(1)} className="row w-100 mx-3 my-0" style={{cursor: "pointer", border: "1px solid gray", padding: "8px 3px"}}>
                        <div style={{cursor: "pointer"}} className="col-1 mx-1 px-0 py-1">
                                <input id="cuota1" className="my-1" style={{height: "18px"}} type="radio" name="cuotas" value="1" required checked={this.state.cuotaSelect === "1"} />
                        </div>

                        <label className="col-10 mx-0 px-0 py-1" style={{cursor: "pointer"}} for="cuota1"  >
                            <div className="d-flex" style={{justifyContent: "space-between", fontSize: "16px"}}>
                                <span style={{fontWeight: "bold"}}>
                                Paga al Contado para Obtener un 50% de Ahorro
                                </span>
                                <span style={{fontWeight: "bold", marginRight: "10px"}}>{this.state.countryCode === "PE" ? this.state.optionCuotasPeru[0] : this.state.optionCuotas[0]}</span>
                            </div>
                        </label>
                 </div>

                 <div onClick={() => this.selectCuota(2)} className="row w-100 mx-3 my-0" style={{cursor: "pointer", border: "1px solid gray", padding: "8px 3px"}} >
                        <div style={{cursor: "pointer"}} className="col-1 mx-1 px-0 py-1">
                                <input id="cuota2" className="my-1" style={{height: "18px"}} type="radio" name="cuotas" value="1" required />
                        </div>

                        <label className="col-10 mx-0 px-0 py-1" style={{cursor: "pointer"}} for="cuota2"  >
                            <div className="d-flex" style={{justifyContent: "space-between", fontSize: "16px"}}>
                                <span style={{fontWeight: "bold"}}>2 cuotas</span>
                                <span style={{fontWeight: "bold", marginRight: "10px"}}>{this.state.countryCode === "PE" ? this.state.optionCuotasPeru[1] : this.state.optionCuotas[1]} / 2 meses</span>
                            </div>
                        </label>
                 </div>

                 <div onClick={() => this.selectCuota(3)} className="row w-100 mx-3 my-0" style={{cursor: "pointer", border: "1px solid gray", padding: "8px 3px"}}>
                        <div style={{cursor: "pointer"}} className="col-1 mx-1 px-0 py-1">
                                <input id="cuota3" className="my-1" style={{height: "18px"}} type="radio" name="cuotas" value="1" required />
                        </div>

                        <label className="col-10 mx-0 px-0 py-1" style={{cursor: "pointer"}} for="cuota3"  >
                            <div className="d-flex" style={{justifyContent: "space-between", fontSize: "16px"}}>
                                <span style={{fontWeight: "bold"}}>5 cuotas</span>
                                <span style={{fontWeight: "bold", marginRight: "10px"}}>{this.state.countryCode === "PE" ? this.state.optionCuotasPeru[2] : this.state.optionCuotas[2]} / 10 meses</span>
                            </div>
                        </label>
                 </div>

                </>
            }
            
        

                </>}

                </div>

            </form>

        </div>







{this.state.cuponActive &&
<div style={{
                        display: "inline-block",
                        color: 'black',
                        boxShadow: '4px 3px 5px 0px #5c9d6b',
                        borderRadius: '10px',
                        fontWeight: 600,
                        fontSize: '19px',
                        padding: '13px',
                        backgroundColor: 'mediumaquamarine'
                      }}>

<div className="section-title mt-2 mb-1 d-flex">

<h3 className="title mb-1" style={{paddingLeft:  window.type_device ? "1px" : "9px"}}>
    🎉 Cupón Activado
</h3>
</div>

<div className="contact-form--1" style={{ paddingTop: "5px" }}>
            <div>
                <div className="row" style={{paddingLeft: !window.type_device ? "10px" : "", paddingRight: !window.type_device ? "10px" : ""}}>
                    <label class="col-12" htmlFor="item01">
                    <b style={{fontSize: "17px"}}>
                
                    ¡Has ahorrado { this.state.countryCode.toLocaleUpperCase() === "PE" ? this.state.ahorroPeru: this.state.ahorroUSD }
                     gracias al código {this.state.slugBootcamp.toLocaleUpperCase()} que ya está aplicado! 🎉💰
                    </b>
                    </label>
                    </div>
                    </div>
                    </div>
</div>
}



{this.state.cupones &&
    <> 

<div className="section-title mt-2 mb-1 d-flex">

<h3 className="title mb-2" style={{paddingLeft:  window.type_device ? "1px" : "9px"}}>
    Ahorra con un Cupón
</h3>
</div>

<div className="contact-form--1" style={{ paddingTop: "10px" }}>
            <div>
                <div className="row" style={{paddingLeft: !window.type_device ? "10px" : "", paddingRight: !window.type_device ? "10px" : ""}}>
                    <label class="col-12" htmlFor="item01">
                    <b style={{fontSize: "17px"}}>
                    ¿Tienes un código de descuento?
                    </b>

                <div className="d-flex">
                    <input
                    type="text"
                    name="cupon"
                    id="item-cupom"
                    value={this.state.Cupon}
                    onChange={(e) => {
                        this.setState({ Cupon: e.target.value });
                    }}
                    placeholder="Escribe o copia aquí"
                    />

                <button className="btn-efect-cupon" style={{backgroundColor: "#1f1f25", fontFamily: "Poppins, sans-serif", marginLeft: "8px", fontWeight: "bold", textTransform: "none", cursor: "pointer"}}
                          onClick={(e) => this.validateCupon()}
                        >
            {this.state.loadingCupon  &&
                <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                style={{fontSize: "20px", marginRight: "8px"}}
                />
            }
             Aplicar
        </button>

                  

                    </div>

               
                </label>
        </div>
    </div>
</div>
</>
}

</>}


{(this.state.prueba && this.state.showPaymentMetod) &&
<div className="pt-3">
    <Alert variant={'success'}>
    <Alert.Heading>
    {`Gracias ${this.state.Name }!, pronto nos pondremos en contacto contigo para la prueba de 24 horas.`}
    <br/>
    </Alert.Heading>
    </Alert>
</div>
}




<div className="container-pay mb-4">

    {/* <p style={{fontSize: "18px", color: "#333"}}>
        Para confirmar tu inscripción, completa el pago aquí:
        </p> */}

    <div className="section-title mt-3 mb-1 d-flex">
        <h3 className="title">
        {true ? "Payment Method" : "Método de Pago"}
        </h3>
    </div>

    {
        false && this.state.countryCode === "PE" &&
        <div className="mb-2">
        <span style={{ fontSize: 16 }}>Selecciona tu método de pago ideal</span>
        </div>
    }
{/* 
    <div className="payment-method selected">
        <input type="radio" name="payment" id="installments" checked readOnly />
        <label htmlFor="installments">
        <div className="payment-header">
            <div className="payment-title" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span>💳</span>
            <span>Plan de 3 Pagos</span>
            <span style={{
                background: "#10B981",
                color: "white",
                padding: "2px 8px",
                borderRadius: "12px",
                fontSize: 12
            }}>RECOMENDADO</span>
            </div>
   
        </div>
        <div className="installment-details">
            <div className="installment-item" style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
            <span>🔐 Hoy (reserva tu plaza):</span>
            <span style={{ fontWeight: 600, color: "#10B981" }}>{this.state.price_view_base}</span>
            </div>
            <div className="installment-item" style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
            <span>📅 2do pago (30 días):</span>
            <span>{this.state.price_view_base}</span>
            </div>
            <div className="installment-item" style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
            <span>📅 3er pago (60 días):</span>
            <span>{this.state.price_view_base}</span>
            </div>
        
        </div>
        </label>
    </div> */}

    <div className="col-12 px-0">
        <div className="d-flex flex-column" >
        
        {true &&
        <div id='modal-card' onClick={() => {
            this.changeMethodPay('card');
        } } style={{
            display: "flex",
            cursor: "pointer", height: "118px", borderRadius: "20px", boxShadow: "rgba(50, 27, 98, 0.47) 6px 5px 15px 0px"}}>
            <div style={{width: "45px", alignSelf: "center", placeSelf: "center", margin: "13px", cursor: "pointer"}}>
                <input  style={{height: "20px", marginLeft: "5px", cursor: "pointer"}} type="radio" checked name="payment" value="card" id='option-card' />
            </div> 

            <div style={{display: "flex", alignItems: "center", maxWidth: "290px", padding: "5px", cursor: "pointer"}}>
                <label for="option-card">
                    <span style={{cursor: "pointer", fontSize: "21px", fontWeight: "bold", color: "#1f1f25", position: "relative", top: "0"}}>
                    
                    {true ? "Debit or credit card": "Tarjeta débito o crédito"}  

                        </span>
                     <img height={'65px'}  className="ayudar" src="/assets/images/dojopy/PAGO-SEGURO-STRIPE.png" alt="métodos de pago" style={{cursor: "pointer", position: "relative", top: "-5px"}}/>
                </label>
            </div>
        </div>
        }


       {false && this.state.countryCode !== 'PE' &&
        <div id='modal-paypal'  onClick={() => {this.changeMethodPay('paypal')}} className="mt-3" style={{display: "none", cursor: "pointer", height: "118px", borderRadius: "20px", border: "1px solid #c6c9d8"}}>
            <div style={{width: "45px", alignSelf: "center", placeSelf: "center", margin: window.type_device ? "4px": "13px", cursor: "pointer"}}>
                <input  style={{height: "20px", marginLeft: "5px", cursor: "pointer"}} type="radio" name="payment" value="paypalPay" id='option-paypal' />
            </div> 

            <div style={{display: "flex", alignItems: "center", maxWidth: "290px", padding: "5px", cursor: "pointer"}}>
                <label for="option-paypal">
                    <span style={{cursor: "pointer", fontSize: "21px", fontWeight: "bold", color: "#1f1f25", position: "relative", top: "7px"}}>
                        <FaCreditCard className="mr-1"/> Reservar Plaza Ahora
                    </span>
                    <img height={'65px'}  className="ayudar" src="/assets/images/dojopy/paypal_.webp" alt="métodos de pago" style={{cursor: "pointer", display: "block" }}/>

                </label>
            </div>
        </div>
        } 

    {false && this.state.countryCode === 'PE' &&
        <div id='modal-deposito'  onClick={() => {this.changeMethodPay('deposito')}} className="mt-3 d-flex" style={{cursor: "pointer", height: "118px", borderRadius: "20px", border: "1px solid #c6c9d8"}}>
            <div style={{width: "45px", alignSelf: "center", placeSelf: "center", margin: window.type_device ? "4px": "13px", cursor: "pointer"}}>
                <input  style={{height: "20px", marginLeft: "5px", cursor: "pointer"}} type="radio" name="payment" value="depositoPay" id='option-deposito' />
            </div> 

            <div style={{display: "flex", alignItems: "center", maxWidth: "290px", padding: "5px", cursor: "pointer"}}>
                <label for="option-deposito">
                    <span style={{cursor: "pointer", fontSize: "21px", fontWeight: "bold", color: "#1f1f25", position: "relative", top: "3px"}}>
                    Transferencia bancaria
                    </span>
                    <div className="mt-2">
                    <img height={'25px'}  className="ayudar" src="/assets/images/dojopy/Logobcp.png" alt="métodos de pago" style={{cursor: "pointer", display: "inline", marginTop: "3px" }}/>
                    {/* <img height={'28px'}  className="ayudar" src="/assets/images/dojopy/BBVA_logo.png" alt="métodos de pago" style={{marginLeft: '16px', cursor: "pointer", display: "inline", marginTop: "3px" }}/> */}
                    </div>

                </label>
            </div>
        </div>
        }
    

    {
        false && this.state.countryCode === 'PE' &&
        <div id='modal-yape'  onClick={() => {this.changeMethodPay('yape')}} className="mt-3 d-flex" style={{cursor: "pointer", height: "118px", borderRadius: "20px", border: "1px solid #c6c9d8"}}>
            <div style={{width: "45px", alignSelf: "center", placeSelf: "center", margin: window.type_device ? "4px": "13px", cursor: "pointer"}}>
                <input  style={{height: "20px", marginLeft: "5px", cursor: "pointer"}} type="radio" name="payment" value="yapePay" id='option-yape' />
            </div> 

            <div style={{display: "flex", alignItems: "center", maxWidth: "290px", padding: "5px", cursor: "pointer"}}>
                <label for="option-yape">
                    <span style={{cursor: "pointer", fontSize: "21px", fontWeight: "bold", color: "#1f1f25", position: "relative", top: "3px"}}>
                    Paga con Yape o Plin
                    </span>
                    <div className="mt-0">
                    <img height={'57px'}  className="ayudar" src="/assets/images/dojopy/plinyape.png" alt="métodos de pago" style={{cursor: "pointer", display: "inline", marginTop: "3px" }}/>
                    </div>

                </label>
            </div>
        </div>
        }
    


    <div className="mt-2 text-center">
        
        <button className="btn-efect btn-efect-2 w-100" style={{backgroundColor: "#1f1f25", fontFamily: "Poppins, sans-serif", fontSize: "21px", margin: "5px", fontWeight: "bold", textTransform: "none", cursor: "pointer"}}
            onClick={(e) => this.CreateLinkPay()}
        >
            {this.state.loadingPay  &&
                <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                style={{fontSize: "18px", marginRight: "7px"}}
                />
            }

            {!this.state.loadingPay  && <>
           <FaCreditCard className="mr-1"/> Complete Payment

            </>}
             


             
        </button>
    </div>


     

        { this.state.showPayal && this.state.countryCode !== 'PE' &&

        <>
            <div style={{
                fontSize: "17px",
                textAlign: "center",
                marginTop: "23px"
            }}>
             Payment Alternative
            </div>
        <button id="comprar-paypal-button" style={{border: "none", width: window.type_device ? "100%": "370px", marginTop: "8px", alignSelf: "center", placeSelf: "center"}}>
            <PayPalScriptProvider options={this.state.initialOptions} style={{height: "200px"}}>
            <PayPalButtons
                    style={{ layout: "horizontal", label: "pay" }} // Cambia a 'vertical' para mejor disposición
                onClick={() => this.onSubmit() }
                createOrder={(data, actions) => {
                    return actions.order.create({
                        purchase_units: [
                            {
                                amount: {
                                    currency_code: this.state.pay_currency_code,
                                    value: this.state.price_payment,
                                },
                            },
                        ],
                    });
                }}
                onApprove={(data, actions) => {
                    return actions.order.capture().then((details) => {
                        window.location.href = '/payment-success';
                        // const name = details.payer.name.given_name;
                        // console.log(`Transaction completed by ${name}`);
                    });
                }}
            />
            </PayPalScriptProvider>
        </button>
        </>

        }





    </div>

</div>

</div>

        </div>
    </div>











<div className="col-12 col-md-6  text-white" style={{boxShadow: "rgb(50 27 98 / 47%) 6px 5px 15px 0px", borderRadius: "20px", background: "rgb(31, 31, 37)", color: "white", marginTop: window.type_device ? "10px": "1px","align-self": "flex-start", "text-align": "center", maxWidth: "500px"}}>
<div className="row mt-3 mb-4 text-white" style={{"justify-content": "center"}}>

<div className="pt-1 pb-1 text-white px-1">
    <h3 style={{color: "white"}} className={`${window.type_device ? "px-2" : "px-1"}`}>
        Bootcamp <br/> Full Stack Developer
    </h3>


    <p>
        {this.state.asunto}
    </p>

  




    {this.state.black_friday && <h6 style={{color: "gold"}}> {this.state.black_friday} </h6>}
    

</div>


<ul className="list-dojopy" style={{fontSize: "17px", textAlign: "left", color: "white"}}>

    <>



    {this.state.duracion &&
                        <li>
                            <b>
                                
                                {true ? "Duration:": "Duración:"}
                            </b>
                            <b style={{fontSize: "17px", marginLeft: "5px"}}>{this.state.duracion} </b> 
                        </li>
                        }
                     
                        <li> <b style={{fontSize: "17px"}}>
                            
                            {true ? "": ""}
                                                           <span style={{display: "inline-block", padding: "3px", marginLeft: "7px", "background-color": "tomato", "border-radius": "7px", "padding-left": "7px", "padding-right": "7px", "color": "white", "font-size": "18px"}}>
                                                        <span className="pulsar"></span> {true ? "En vivo": "Live"}
                                                    </span>
                                                    <span style={{display: "inline-block", padding: "3px", marginLeft: "7px", "background-color": "slateblue", "border-radius": "7px", "padding-left": "7px", "padding-right": "7px", "color": "white", "font-size": "18px"}}>
                                                                Asíncrono
                                                            </span>
                            </b></li>
                    
                         <li>
                                {true ? "Comprehensive program designed to boost your professional career.": "Programa completo diseñado para impulsar tu carrera profesional."}
                            
                            </li> 
                        
                         {!this.state.showMore &&
                            <button
                                                onClick={() => this.setState({showMore: true}) }
                                                type="submit"
                                                name="submit"
                                                id="mc-embedded-subscribe-"
                                                style={{ marginTop: "5px", marginBottom: "5px", fontSize: "18px", color: "white",
                                                    textAlign: "center",
                                                "border-radius": "20px",
                                                "border": "1px solid white",
                                                "padding": "7px 13px",
                                                width: "90%"

                                            }}
                                                >
                                                 {true ? "Show more": "Mostrar más"}
                                                <AiOutlineDown style={{padding: "5px", fontSize: "28px"}}/>
                                                </button>
                        }


{(this.state.showMore && true) && <>
<li>1:1 professional support throughout the Bootcamp.</li>
<li>Active community and professional support.</li>
<li>Digital certification.</li>
<li>Access to the Bootcamp Platform.</li>
<li>Access to the employability program.</li>
<li>Apply what you have learned with weekly projects and stand out in the job market.</li>
                        </>}

                     
                        
{(this.state.showMore && !true) && <>
                        <li>Apoyo profesional 1:1 durante todo el Bootcamp.</li>
                            <li>Comunidad activa y soporte profesional.</li>
                            <li>Certificación digital.</li>
                            <li>Acceso a la Plataforma del bootcamp.</li> 
                            <li>Acceso al programa de empleabilidad.</li>
                            <li>Aplica lo aprendido con proyectos semanales y destaca en el mercado laboral.</li>
                        </>}
                        

 
</>

</ul>

   
<div>



</div>
 
    <div className="col-10" style={{"margin": "20px", "width": "100%", "border": "1px solid #ffffff85"}}></div>
    
    {!this.state.cuotas &&
        <>

        {!window.location.pathname.includes("descuento") &&
        <>
        <div className="col-7">
            <h4 style={{fontSize: "1.2rem", color: "white"}}> 
                {this.state.isFlashEspecial ? "Costo Regular": true ? "Total Value": "Valor Total"  }
            </h4>
        </div>

        <div className="col-5 px-1">
            <h4 style={{fontSize: "1.4rem", color: "white", fontWeight: "normal", marginBottom :"7px"}}>
                <del style={{color: "lightslategray"}}>{this.state.price_view_descuento} </del>
                {this.state.porcentajeDescuento &&  <div className="discount-badge" style={{display: "inline-block", marginLeft: "8px", fontSize: "14px"}}> {this.state.porcentajeDescuento} </div> }
            </h4>
        </div>
           </>
        }

        { window.location.pathname.includes("descuento")  && this.state.countryCode === "PE" &&
        <>
          <div className="col-7">
            <h4 style={{fontSize: "1.2rem", color: "white"}}> 
                Costo regular
            </h4>
        </div>

        <div className="col-5 px-1">
            <h4 style={{fontSize: "1.4rem", color: "white", fontWeight: "normal", marginBottom :"7px"}}>
                <del style={{color: "lightslategray"}}> S/2,000 </del>
                {this.state.porcentajeDescuento &&  <div className="discount-badge" style={{display: "inline-block", marginLeft: "8px", fontSize: "15px"}}> {this.state.porcentajeDescuento} </div> }
            </h4>
        </div>
        </>
        }

        { window.location.pathname.includes("descuento")  && this.state.countryCode !== "PE" &&
        <>
          <div className="col-7">
            <h4 style={{fontSize: "1.2rem", color: "white"}}> 
                Costo regular
            </h4>
        </div>

        <div className="col-5 px-1">
            <h4 style={{fontSize: "1.4rem", color: "white", fontWeight: "normal", marginBottom :"7px"}}>
                <del style={{color: "lightslategray"}}> $570 USD </del>
                {this.state.porcentajeDescuento &&  <div className="discount-badge" style={{display: "inline-block", marginLeft: "8px", fontSize: "15px"}}> {this.state.porcentajeDescuento} </div> }
            </h4>
        </div>
        </>
        }




        <div className="col-7 mt-2">
            <h4 style={{fontSize: "1.2rem", color: "white"}}>  
                
                {true ? "Cash payment": "Pago único"}
            </h4>
        </div>

        <div className="col-5 px-1 mt-2" style={{placeSelf: "center"}}>
            <h4 style={{fontSize: "1.4rem", color: "white"}} >
                {this.state.price_view_base}
            </h4>
        </div>

        </>
    }
 
 {this.state.cuotas &&
 <>
        
        {this.state.cuotaSelect === "1" &&
        <>
         <div className="col-7">
            <h4 style={{fontSize: "1.2rem", color: "white"}}> 
                Precio Regular
            </h4>
        </div>

        <div className="col-5 px-1">
            <h4 style={{fontSize: "1.4rem", color: "white", fontWeight: "normal", marginBottom :"7px"}}>
                <del style={{color: "white"}}>{this.state.price_view_descuento} </del>
            </h4>
        </div>
        </>
        }
       

 <div className="col-7 mt-2">
            <h4 style={{fontSize: "1.2rem", color: "white"}}>  
            

            {this.state.cuotaSelect === "1" ? "Plan de 3 Pagos": "En 2 cuotas"}
            </h4>
        </div>

        <div className="col-5 px-1 mt-2" style={{placeSelf: "center"}}>
            <h4 style={{fontSize: "1.4rem", color: "white"}} >
                {this.state.price_view_base}
            </h4>
        </div>
 </>
    }




  

    

    <div className="p-3 text-left mt-2 text-white">

   <div class="guarantee my-1">
            <div class="guarantee-text">
                🛡️ 30-Day Satisfaction Guarantee or Your Money Back.
            </div>
        </div>


    <h4 className="text-white py-0 mt-4">
        {!true ? "Métodos de pago: ": "Payment Methods:"}
    </h4>
    <p className="text-white">
        Pay with Debit or Credit Card.
         <br/>
   {this.state.countryCode !== 'CA' &&
        "The price is in US Dollars (USD)"
        }

    {this.state.countryCode === 'CA' &&
        "Prices are in Canadian dollars (CAD)."
        }
    </p>

    <div style={{marginTop: "10px"}} className="section-title service-style--3 text-left mb--20 mb_sm--0 ">
<img height="70px" className="ayudar" src="/assets/images/dojopy/payment-card.png" alt="métodos de pago"/>

{/* {this.state.countryCode === 'PE' &&
    <img height={'55px'}  className="ayudar" src="/assets/images/dojopy/plinyape.png" alt="métodos de pago" style={{display: "block", marginTop: "3px" }}/>
} */}
</div>

<div class="secure-badge">
                    🔒 100% Secure and Encrypted Payment
                </div>

    </div>
</div>
</div>


<div style={{marginTop: "50px"}} className="section-title service-style--3 text-left">
            

                        <h5 className="title text-black">

                        {true ? "Once our support team has verified the payment, you will get:": "Una vez que nuestro equipo de soporte haya verificado el pago, obtendrás:"}

                                
                            </h5>
                        <p>
                            <ul>
                                <li>
                                {true ? "Get your credentials and access the Live Online Bootcamp Platform.": "Obtén tus credenciales y accede a la Plataforma del Bootcamp Online en Vivo."}
                                </li>
                                <li>
                                {true ? "Become part of our exclusive private members community and connect with other passionate people like you.": "Forma parte de nuestra exclusiva comunidad privada de miembros y conecta con otros apasionados como tú."}
                                </li>

                                <li>
                                {true ? "Enjoy the personalized support of an assigned mentor, always ready to guide and support you on your path.": "Disfruta del respaldo personalizado de un mentor asignado, siempre listo para guiarte y apoyarte en tu camino."}
                                </li>
                              
                            </ul>

                        
                             </p>

              <p className="mt-4">
  If you have any questions, please write to us via phone or email:<br />
  <strong>Email:</strong> <a href="mailto:hello@dojofullstack.com">hello@dojofullstack.com</a>
</p>



{/* <div className="mb-2 col-12 col-md-6" style={{paddingTop: "5px", paddingBottom: "5px" }}>
    <button
      onClick={() => {
        this.eventPing("ViewContent");
        this.OpenWS();
      }}
      disabled={this.state.loadingEnroll}
      id="submit-contacto"
className="btn-efect-live"
   style={{background: "mediumspringgreen", borderRadius: "15px", color: "#1d1d24", width: "100%", fontSize: "18px", display: "block", margin: "auto", textTransform: "capitalize"}}>
<FaWhatsapp style={{fontSize: "23px", marginRight: "10px"}}/>

{true ? "Talk to an advisor": "¿Tienes una pregunta?"}
</button>
</div> */}


                    </div>

                            </div>
                        </div>
                    </div>
                </div>
                {/* End About Area */}










  {/* Start About Area */}
  {this.state.showTestimonial &&
    <>
      <div className="container px-1 mt-5" data-aos="fade-right" >
            <h2 className="title mb-2 mt-1 mx-2" style={{fontSize: window.type_device ? "36px": "37px"}} >
            Testimonios de Nuestros Alumnos
                </h2>
                <span
                     style={{fontStyle: "italic", display: "block", padding: "3px", marginLeft: "7px", "border-radius": "7px", "color": "black", "font-size": window.type_device ? "19px": "30px" }}>
                          Más de 300 Alumnos Satisfechos
                    </span>
        </div>
  
      <div className="about-area bg_color--5">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                            
                            <div className="col-md-6 col-12 mt-1 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Judith</h3>
                                        <h3 className="title" style={{color: "orange"}}>⭐ Consiguió Empleo</h3>
                                            <div>
                                            <iframe loading="lazy"  width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/alN6nU5a2Vo" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                            </div>
                                        </div>  
                                    </div>
                                </div>

                                <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Bladimir</h3>
                                        <h3 className="title" style={{color: "orange"}}>⭐ Consiguió Empleo</h3>
                                            <div>
                                            <iframe loading="lazy"  width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/dDPWdY-S8-0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Tatiana</h3>
                                            <div>
                                            <iframe loading="lazy"  width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/NhOFeo9_rA4?si=_LWhcwSgAOlmF0Od" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Harold Ivan</h3>
                                            <div>
                                            <iframe loading="lazy"  width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/CJWjmlO3_7k?si=0VWDgUmLhp4pyNRg" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                              

                                {!this.state.showMore &&
                                            <div className="col-12 text-center" style={{marginBottom: "80px"}}>
                                                <button
                                                onClick={() => this.setState({showMore: true}) }
                                                type="submit"
                                                name="submit"
                                                id="mc-embedded-subscribe-"
                                                style={{ marginTop: "5px", marginBottom: "5px", fontSize: "18px",
                                                "border-radius": "20px",
                                                "border": "2px solid #6a5acd",
                                                "padding": "9px 20px"

                                            }}
                                                >
                                                {!true ? "Mostrar más": "Show more"} <br/>
                                                <AiOutlineDown style={{padding: "5px", fontSize: "30px"}}/>
                                                </button>
                                            </div>}



{this.state.showMore &&
                                  <>

                                  <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Stephany</h3>
                                            <div>
                                            <iframe loading="lazy"  width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/330Wxw_z4_0?si=Ms_tnorjQRspKGrw" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Ricardo Osorio</h3>
                                            <div>
                                            <iframe loading="lazy"  width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/ZaR2-71Kg9Q?si=pz_7oW3sL6gOP2oG" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                {/* <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title">Testimonio Diana</h3>
                                            <div>
                                            <iframe loading="lazy"  width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/gpLkbRA4ZrE?si=UV0v9lnJQn2IdwAA" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-6 col-12 mt-3 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                            <h3 className="title">Testimonio Paul</h3>
                                            <div>
                                            <iframe loading="lazy"  width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/81xtrnKV9Ss" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}



                                <div className="col-md-6 col-12 mt-4 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title pt-4">Testimonio Oscar</h3>
                                            <div>
                                            <iframe loading="lazy"  width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/qtu4qNnBZbI" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-12 mt-4 mb-2">
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{marginTop: "10px"}}>
                                        <h3 className="title pt-4">Testimonio Andrés</h3>
                                            <div>
                                            <iframe loading="lazy"  width={window.type_device ? "350": "560"} height="315" src="https://www.youtube.com/embed/Xxif1Dc_ifQ" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                  </>

}
                              




                            </div>
                        </div>
                    </div>
                </div>
      </>
  }











 
</div>


{this.state.showButton && (
              <div className="floating-button-container">

<div className=" floating-button" style={{boxShadow: "none", padding: "8px"}}>
<a href={"#empezar"}>
<button className="btn-efect-2" style={{padding: "10px 25px", fontSize: '21px', textTransform: "none", fontFamily: "Poppins, sans-serif"}} >
    EMPEZAR INSCRIPCIÓN
</button>
</a>
</div>

                    </div>
    )}



   





                <Modal show={this.state.isOpen} size="lg" onHide={this.openModal} >
                    <Modal.Body>
                        <img alt="certificado Desarrollador Web Full Stack" src="/assets/images/dojopy/CERTIFICADO_fullstack_js.webp"></img>
                    </Modal.Body>
                    <Modal.Footer style={{"justify-content": "center"}}>
                    <button className="rn-btn" onClick={this.openModal}>{!true ? "Cerrar": "Close"}</button>
                    </Modal.Footer>
                </Modal>


                <Modal show={this.state.isOpen2} size="md" onHide={() => this.setState({isOpen2: !this.state.isOpen2})} style={{zIndex: "9999999999"}} >
                <span style={{textAlign: "left", "color":"slateblue"}}> <IoCloseCircleOutline onClick={() => this.setState({isOpen2: !this.state.isOpen2})} style={{ cursor: "pointer", fontSize: "35px", marginLeft: "12px", marginTop: "12px", color: "slateblue"}} /> </span>

                    <Modal.Body>
                    <div className="about-inner pt-3">
                        <div className="section-title">
                            <p>
No te preocupes. Nuestros programas son aptos para principiantes y no requieren ningún conocimiento previo ni hay limite de edad.
Además, no estarás solo. Nuestro equipo estará a tu lado para guiarte en el proceso, ayudarte a establecer objetivos y a tener éxito.
                            </p>
                            <p>
                                <b>*Instalar la herramienta de transmisión en vivo:</b>
                                <img style={{borderRadius: "10px"}} alt="canal zoom" height="55px" src="/assets/images/dojopy/zoom_.webp"></img>
                            </p>
                    </div>
                    </div>
                    </Modal.Body>
                    <Modal.Footer style={{"justify-content": "center"}}>
                    <button className="rn-btn" onClick={() => this.setState({isOpen2: !this.state.isOpen2})} >{!true ? "Cerrar": "Close"}</button>
                    </Modal.Footer>
                </Modal>

<Modal show={this.state.isModalBecaOff} size={window.type_device ? "md": "lg"} onHide={() => this.setState({isModalBecaOff: true})} style={{zIndex: "9999999999"}} >
<Modal.Body>
<div className="about-inner inner">
    <div className="section-title">
      <h3 className="mt-3 p-2 text-black" style={{lineHeight: "35px"}}>¡La Beca y Descuento ha Expirado! ⏳</h3>
        <p className="p-1 text-black">
        ¡Lo sentimos! El tiempo para aplicar a la beca y descuento ha expirado. <br/>
        Te animamos a estar atento a futuras oportunidades. ¡Gracias! <br/>
        </p>

        <p className="p-1 text-black">
            <mark>
            El costo actual es: <b>  {this.state.price_view_descuento}</b>
            </mark>
        </p>


        <div className="w-100 m-1">
          <a  href={`/enroll/${this.state.slugOficial}/${this.state.countryCode}`}> 
          <button className="btn-efect">
          Inscríbete Aquí
            </button>
          </a>
        </div>

        <div className="mt-3">
        <p className="p-1 text-black">
            <b>
            ¡Contáctanos por WhatsApp para evaluar la posibilidad de obtener una beca y descuento especial! <br/>
            </b>
        <a  target="_blank" href={"https://api.whatsapp.com/send?phone=51936670597&text=Hola%2C%20informes%20sobre%20la%20beca%20del%20Bootcamp%20Full%20Stack."}> 
          <button className="btn-efect-live">
          Contáctanos Aquí
            </button>
          </a>
        </p>
        </div>

</div>
</div>
</Modal.Body>
</Modal>


                <FooterTwo langUS={true}  />

            </React.Fragment>
        )
    }



    
    runtDiscountHot(country){
        console.log("module runDiscountFlash!");

        const getCookieValue = (name) => {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        }

        const discount60mValue = getCookieValue(`discount-temporal-${this.props.match.params.bootcamp.toLowerCase()}`);
        const discount24hValue = getCookieValue(`discount-reboot-${this.props.match.params.bootcamp.toLowerCase()}`);

        if (discount60mValue){
            console.log("DESCUENTO ACTIVO!");
            const discount60mDate = new Date(parseInt(discount60mValue, 10));
            // console.log(discount60mDate);
            this.setState({timeCounter: discount60mDate})
            return;
        }


        if ( !discount60mValue && !discount24hValue){
            console.log("CREANDO DESCUENTO!");

            const fechaActual = new Date();
            const fechaActual2 = new Date();
    
            const minutes = 60*24;
            const houresReboot = 24;
    
            fechaActual.setTime(fechaActual.getTime() +  (minutes * 60 * 1000) );
            fechaActual2.setTime(fechaActual2.getTime() +  (houresReboot * 60 * 60 * 1000) );
    
            document.cookie = `discount-temporal-${this.props.match.params.bootcamp.toLowerCase()}=${fechaActual.getTime()};expires=${fechaActual.toUTCString() }; path=/`;
            document.cookie = `discount-reboot-${this.props.match.params.bootcamp.toLowerCase()}=${fechaActual2.getTime()};expires=${fechaActual2.toUTCString() }; path=/`;
            this.setState({timeCounter: fechaActual})
        } else if (!discount60mValue && discount24hValue){
            console.log("FINALIZO EL DESCUENTO!");
            this.setState({showDeadLine: false});
            window.location.href = `/`;
        }
       
    }


    async componentDidMount() {

        window.fbq('track', 'AddToCart', {
            value: 2000,                 // Valor total de la compra
            currency: 'USD',               // Moneda utilizada (ISO 4217)
            content_type: 'product',       // Tipo de contenido
            content_ids: ['bootcamp'],  // ID del producto o identificador
            content_name: 'bootcamp'
          });


        if (window.location.pathname.includes("en-fullstack")){
            this.setState(
                {
                    langUS: true,
                    }
            )
        }


        function gtagSendEvent(url) {
            var callback = function () {
              if (typeof url === 'string') {
                window.location = url;
              }
            };
            window.gtag('event', 'conversion_event_page_view', {
              'event_callback': callback,
              'event_timeout': 2000,
              // <event_parameters>
            });
            return false;
          }
        
        gtagSendEvent(window.location);

    
        const isParameterPresent = (param) => {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.has(param);
        }


        window.urlWasi = this.GetLinkWS();

        let country = this.props.match.params.country.toUpperCase();
        const slugBootcamp = this.props.match.params.bootcamp.toLowerCase();

        // country = "CA";

        // axios.get('https://ipapi.co/json/').then((response) => {
        //     let data = response.data;
        //     // window.location.href = `/inscripcionUSA/${slugBootcamp}/${data.country}`;

        //     // if (data.country.toLocaleUpperCase() === "CA" || data.country.toLocaleUpperCase() === "US" || slugBootcamp === "fullstack-usa"){
        //     //     this.setState({isCountryUsa: true});
        //     // }

        // }).catch((error) => {
        //     console.log(error);
        // });


        if (country === "CA"){
            this.setState({
                            payOption: "card",
                            pay_currency_code: "CAD",
                            initialOptions: {
                clientId: "AZeHtz9ynRf6LBFEZCIwQcl-wGC6rVlfGKTH44LBcZ9BVs-INyQQ3VpFYAFWAdX2m2GjMhZBmTQ4Dw-C",
                currency: "CAD",
                intent: "capture",
                locale: "en_CA",
            }})
        } else {

            this.setState({
                        payOption: "card",
                        pay_currency_code: "USD",
                        initialOptions: {
            clientId: "AZeHtz9ynRf6LBFEZCIwQcl-wGC6rVlfGKTH44LBcZ9BVs-INyQQ3VpFYAFWAdX2m2GjMhZBmTQ4Dw-C",
            currency: "USD",
            intent: "capture",
            locale: "en_US",
        }})
        }


        this.setState(
            {
                countryCode: country,
                slugBootcamp: slugBootcamp,
                optionPlanPago: slugBootcamp,
                }
        );


        
        const email = localStorage.getItem('email') || "";
        const name = localStorage.getItem('name') || "";
        const phone = localStorage.getItem('phone') || "";

        if (email){
            this.setState({Email: email});
        }
        if (name){
            this.setState({Name: name});
        }
        if (phone){
            this.setState({Phone: phone});
        }
     

        axios.get('https://hiuaik2gocmwdeh2ub6lqz3hxq0ycvbe.lambda-url.us-east-1.on.aws/').then((response) => {
            const dataApi = response.data;

            try {
                const asunto = dataApi[slugBootcamp].asunto || '';

                const title = dataApi[slugBootcamp].title;
                const unicoPago = dataApi[slugBootcamp].unico_pago;
                const pagoCuota = dataApi[slugBootcamp].cuota;
                const planPago = dataApi[slugBootcamp].planPago || false;
                const fecha_inicio = dataApi[slugBootcamp].fecha_inicio || "";
                const duracion = dataApi[slugBootcamp].duracion || "";

                const isFlex = dataApi[slugBootcamp].is_flex || false;
                const isCurso = dataApi[slugBootcamp].isCurso;

                // const slugPlanes = dataApi[slugBootcamp].slugPlanes;
                // const KeysPlanes = dataApi['bootcamp-planes'][slugPlanes];
                const cuotas = dataApi[slugBootcamp].cuotas || false;
                const fechasPago = dataApi[slugBootcamp].fechasPago || [];
                const fechas = dataApi[slugBootcamp].fechas || [];

                const fechaLimite = dataApi[slugBootcamp].fechaLimite || '';
                const isFlashEspecial = dataApi[slugBootcamp].isFlashEspecial || false;
                const FlashBody = dataApi[slugBootcamp].FlashBody || '';
                const modeIntro = dataApi[slugBootcamp].modeIntro || '';

                const activeBeca = dataApi[slugBootcamp].activeBeca;
                const slugOficial = dataApi[slugBootcamp].slugOficial || '';
                const priceConversion = dataApi[slugBootcamp].priceConversion || '';
                const garantia = dataApi[slugBootcamp].garantia || '';
                const porcentajeDescuento = dataApi[slugBootcamp]?.porcentajeDescuento || '';
                const linkPayPeru = dataApi[slugBootcamp].linkPayPeru || '';
                const linkPayUSD = dataApi[slugBootcamp].linkPayUSD || '';
                const linkPayMXN = dataApi[slugBootcamp].linkPayMXN || '';
                const cupones = dataApi[slugBootcamp].cupones || '';
                const cuponActive = dataApi[slugBootcamp].cuponActive || '';
                const ahorroPeru = dataApi[slugBootcamp].ahorroPeru || '';
                const ahorroUSD = dataApi[slugBootcamp].ahorroUSD || '';
                const optionCuotas = dataApi[slugBootcamp].optionCuotas || '';
                // const optionCuotasPeru = dataApi[slugBootcamp].optionCuotasPeru || '';

                const linkPayPeru2 = dataApi[slugBootcamp].linkPayPeru2 || '';
                const linkPayPeru3 = dataApi[slugBootcamp].linkPayPeru3 || '';
                const linkPayUSD2 = dataApi[slugBootcamp].linkPayUSD2 || '';
                const linkPayUSD3 = dataApi[slugBootcamp].linkPayUSD3 || '';
                const langUS = dataApi[slugBootcamp].langUS || false;

                // const linkPayUSD4 = dataApi[slugBootcamp].linkPayUSD4 || '';

                if (isFlashEspecial) {
                    this.runtDiscountHot(country);

                    const timer = setTimeout(() => {
                        this.setState({ showDeadLine: true });
                      }, 2000); // 3 segundos

                }

                this.setState({fechas:fechas, isCurso: isCurso, pagoCuota: pagoCuota, unicoPago: unicoPago, title: title, dataApi: dataApi,
                    isFlex: isFlex, planPago: planPago, fecha_inicio: fecha_inicio, cuotas: cuotas,
                    fechasPago: fechasPago,
                    duracion,
                    fechaLimite,
                    isFlashEspecial,
                    FlashBody,
                    modeIntro,
                    activeBeca,
                    slugOficial,
                    priceConversion,
                    garantia,
                    porcentajeDescuento,
                    linkPayPeru,
                    linkPayUSD,
                    linkPayMXN,
                    cupones,
                    cuponActive,
                    ahorroPeru,
                    ahorroUSD,
                    optionCuotas,
                    linkPayPeru2,
                    linkPayPeru3,
                    linkPayUSD2,
                    linkPayUSD3,
                    asunto,
                    langUS
                });
                this.DynamicCountry(country, dataApi, slugBootcamp);
                


            } catch (error) {
                console.log(error);
                // window.location.href = '/';
            }
            

            }).catch((error) => {
                console.log(error);
            });


 

    // this.sleep(15000).then(r => {
    //     // const enlace = document.getElementById('whatsapp-btn');
    //     document.getElementById('whatsapp').style.display='block';
    //     const nuevaUrl = 'https://api.whatsapp.com/send?phone=51936670597&text=Hola, me gustaría obtener más información sobre el bootcamp de desarrollador full stack.';
    //     })


      }

}

export default InscripcionUSA;
